import platform from '@propertypal/shared/src/utils/platform';
import FeaturedListingContent from '@propertypal/web-ui/src/promote/FeaturedListingContent';
import Head from 'next/head';
import React from 'react';
import generateMetaTags from '../../../components/layout/MetaTags';

const metaData = {
  title: `Featured Listing - ${platform.title}`,
  // eslint-disable-next-line max-len
  description: `Promote Your Listing On ${platform.title} To Get More Exposure And Put Your Property In Front Of The Right People.`,
  url: `/products/estate-agents/featured-listing`,
};

const FeaturedListingPage = () => {
  return (
    <>
      <Head>{generateMetaTags(metaData)}</Head>

      <FeaturedListingContent products />
    </>
  );
};

export default FeaturedListingPage;
